import request from "@/utils/request";

export function fetchCarousel() {
  return request({
    url: "/Carousel/index",
    method: "post",
  });
}

export function fetchAbout() {
  return request({
    url: "/index/about",
    method: "post",
  });
}

export function fetchContact() {
  return request({
    url: "/index/contactUs",
    method: "post",
  });
}

export function uploadFile(file) {
  const formData = new FormData();
  formData.append("file", file);

  return request({
    url: "/common/upload",
    method: "post",
    data: formData,
  });
}

export function fetchUserInfo() {
  return request({
    url: "/user/getUserInfo",
    method: "post",
  });
}

export function updatePassword(params) {
  const formData = new FormData();
  Object.keys(params || {}).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null) {
      formData.append(key, params[key]);
    }
  });

  return request({
    url: "/user/resetpwd",
    method: "post",
    data: formData,
  });
}

export function sendSms(params) {
  const formData = new FormData();
  Object.keys(params || {}).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null) {
      formData.append(key, params[key]);
    }
  });

  return request({
    url: "/Sms/send",
    method: "post",
    data: formData,
  });
}

export function fetchGrades() {
  const formData = new FormData();
  return request({
    url: "/Grade/index",
    method: "post",
    data: formData,
  });
}

export function getGradeBooks(gradeId, page = 1, limit = 10) {
  const formData = new FormData();
  formData.append("type", "grade");
  formData.append("grade_id", gradeId);
  formData.append("page", page);
  formData.append("limit", limit);
  return request({
    url: "/Book/index",
    method: "post",
    data: formData,
  });
}

export function getBookAllUnits(bookId) {
  const formData = new FormData();
  formData.append("book_id", bookId);
  return request({
    url: "/Book/getBookAllUnits",
    method: "post",
    data: formData,
  });
}

export function getUnitsAllQuestions(unitId) {
  const formData = new FormData();
  formData.append("unit_id", unitId);
  return request({
    url: "/Exercises/getUnitsAllQuestions",
    method: "post",
    data: formData,
  });
}

export function getUnitsAllQuestionsError(unitId) {
  const formData = new FormData();
  formData.append("unit_id", unitId);
  return request({
    url: "/Exercises/getUnitsAllQuestionserror",
    method: "post",
    data: formData,
  });
}

export function getUnitsAllVocabularys(unitId) {
  const formData = new FormData();
  formData.append("unit_id", unitId);
  return request({
    url: "/Book/getUnitsAllVocabularys",
    method: "post",
    data: formData,
  });
}

export function getReadingComprehensionVocabulary(unitId) {
  const formData = new FormData();
  formData.append("unit_id", unitId);
  return request({
    url: "/Exercises/getUnitsAllVocabularys",
    method: "post",
    data: formData,
  });
}

export function getMistakebookUnitsAllVocabularys(unitId) {
  const formData = new FormData();
  formData.append("unit_id", unitId);
  return request({
    url: "/Mistakebook/getUnitsAllVocabularys",
    method: "post",
    data: formData,
  });
}

export function addToFamiliarWords(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("vocabulary_ids", params.vocabularyIds);
  return request({
    url: "/Study/addToFamiliarWords",
    method: "post",
    data: formData,
  });
}

export function addToWillnotWords(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("vocabulary_ids", params.vocabularyIds);
  return request({
    url: "/Study/addToWillnotWords",
    method: "post",
    data: formData,
  });
}

export function getUnitFirstWord(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("type", params.type);
  return request({
    url: "/Study/getUnitFirstWord",
    method: "post",
    data: formData,
  });
}

export function getMistakebookUnitFirstWord(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("type", params.type);
  formData.append("learn_type", params.learnType);
  return request({
    url: "/Mistakebook/getUnitFirstWord",
    method: "post",
    data: formData,
  });
}

export function getReadingComprehensionUnitFirstWord(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("type", params.type);
  return request({
    url: "/Exercises/getUnitFirstWord",
    method: "post",
    data: formData,
  });
}

export function getReadingComprehensionNextWord(params) {
  const formData = new FormData();
  formData.append("type", params.type);
  formData.append("difficult_vocabulary_id", params.difficultVocabularyId);
  formData.append("current_index", params.currentIndex);
  return request({
    url: "/Exercises/getNextWord",
    method: "post",
    data: formData,
  });
}

export function submitReadingComprehensionAnswer(params) {
  const formData = new FormData();
  formData.append("type", params.type);
  formData.append("difficult_study_id", params.difficultStudyId);
  formData.append("difficult_vocabulary_id", params.difficultVocabularyId);
  formData.append("current_index", params.currentIndex);
  formData.append("action", params.action);
  formData.append("answer", params.answer);
  return request({
    url: "/Exercises/submitAnswer",
    method: "post",
    data: formData,
  });
}

export function initReadingComprehensionTest(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("type", params.type);
  return request({
    url: "/Exercises/initTest",
    method: "post",
    data: formData,
  });
}

export function getReadingComprehensionTestFirst(params) {
  const formData = new FormData();
  formData.append("hip_test_id", params.hipTestId);
  formData.append("type", params.type);
  return request({
    url: "/Exercises/getUnitTestFirst",
    method: "post",
    data: formData,
  });
}

export function getReadingComprehensionNextTest(params) {
  const formData = new FormData();
  formData.append("hip_test_id", params.hipTestId);
  formData.append("type", params.type);
  formData.append("current_index", params.currentIndex);
  return request({
    url: "/Exercises/getNextUnitTest",
    method: "post",
    data: formData,
  });
}

export function getNextWord(params) {
  const formData = new FormData();
  formData.append("type", params.type);
  formData.append("difficult_vocabulary_id", params.difficultVocabularyId);
  formData.append("current_index", params.currentIndex);
  return request({
    url: "/Study/getNextWord",
    method: "post",
    data: formData,
  });
}

export function getMistakebookNextWord(params) {
  const formData = new FormData();
  formData.append("type", params.type);
  formData.append("difficult_vocabulary_id", params.difficultVocabularyId);
  formData.append("current_index", params.currentIndex);
  formData.append("learn_type", params.learnType);
  return request({
    url: "/Mistakebook/getNextWord",
    method: "post",
    data: formData,
  });
}

export function getBookSentencesFirst(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  return request({
    url: "/Study/getBookSentencesFirst",
    method: "post",
    data: formData,
  });
}

export function getBookSentencesNext(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("current_index", params.currentIndex);
  return request({
    url: "/Study/getBookSentencesNext",
    method: "post",
    data: formData,
  });
}

export function initMistakebookTest(params) {
  const formData = new FormData();
  formData.append("type", params.type); 
  formData.append("unit_id", params.unitId);
  return request({
    url: "/Mistakebook/initTest",
    method: "post",
    data: formData,
  });
}

export function getMistakebookUnitTestFirst(params) {
  const formData = new FormData();
  formData.append("hip_test_id", params.hipTestId);
  formData.append("type", params.type); 
  return request({
    url: "/Mistakebook/getUnitTestFirst",
    method: "post",
    data: formData,
  });
}

export function getMistakebookNextUnitTest(params) {
  const formData = new FormData();
  formData.append("hip_test_id", params.hipTestId);
  formData.append("type", params.type); 
  formData.append("current_index", params.currentIndex);
  return request({
    url: "/Mistakebook/getNextUnitTest",
    method: "post",
    data: formData,
  });
}

export function submitMistakebookTestAnswers(params) {
  const requestData = {
    hip_test_id: params.hipTestId,
    unit_id: params.unitId,
    type: params.type, 
    answer: params.answer, 
  };
  return request({
    url: "/Mistakebook/submitTestAnswers",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: requestData,
  });
}

export function getHomeMsgTotal() {
  const formData = new FormData();
  return request({
    url: "/Notice/getHomeMsgTotal",
    method: "post",
    data: formData,
  });
}

export function getNoticeList(page, limit, type) {
  const formData = new FormData();
  formData.append("page", page);
  formData.append("limit", limit);
  formData.append("type", type);
  return request({
    url: "/Notice/getList",
    method: "post",
    data: formData,
  });
}

export function getNoticeTotal() {
  const formData = new FormData();
  return request({
    url: "/Notice/getNoticeTotal",
    method: "post",
    data: formData,
  });
}

export function doReadNotice(type, notice_id) {
  const formData = new FormData();
  formData.append("type", type);
  formData.append("notice_id", notice_id);
  return request({
    url: "/Notice/doRead",
    method: "post",
    data: formData,
  });
}

export function getSignList() {
  const formData = new FormData();
  return request({
    url: "/sign/index",
    method: "post",
    data: formData,
  });
}

export function doSign(day) {
  const formData = new FormData();
  formData.append("day", day);
  return request({
    url: "/sign/doSign",
    method: "post",
    data: formData,
  });
}

export function getUserStudyDuration(year) {
  const formData = new FormData();
  formData.append("year", year);
  return request({
    url: "/Studyduration/getUserStudyDuration",
    method: "post",
    data: formData,
  });
}

export function addStudyDuration(duration) {
  const formData = new FormData();
  formData.append("duration", duration);
  return request({
    url: "/Studyduration/addStudyduration",
    method: "post",
    data: formData,
  });
}

export function updateUserProfile(avatar) {
  const formData = new FormData();
  formData.append("avatar", avatar);
  return request({
    url: "/user/profile",
    method: "post",
    data: formData,
  });
}

export function submitAnswer(params) {
  const formData = new FormData();
  formData.append("type", params.type); 
  formData.append("difficult_study_id", params.difficultStudyId);
  formData.append("difficult_vocabulary_id", params.difficultVocabularyId);
  formData.append("current_index", params.currentIndex);
  formData.append("action", params.action); 
  formData.append("answer", params.answer);
  return request({
    url: "/Study/submitAnswer",
    method: "post",
    data: formData,
  });
}

export function initUnitTest(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("type", params.type); 
  return request({
    url: "/Unittest/initTest",
    method: "post",
    data: formData,
  });
}

export function getUnitTestFirst(params) {
  const formData = new FormData();
  formData.append("hip_test_id", params.hipTestId);
  formData.append("type", params.type); 
  if (params.grouping) {
    formData.append("grouping", params.grouping);
  }
  return request({
    url: "/Unittest/getUnitTestFirst",
    method: "post",
    data: formData,
  });
}

export function getNextUnitTest(params) {
  const formData = new FormData();
  formData.append("hip_test_id", params.hipTestId);
  formData.append("type", params.type); 
  formData.append("current_index", params.currentIndex);
  if (params.grouping) {
    formData.append("grouping", params.grouping);
  }
  return request({
    url: "/Unittest/getNextUnitTest",
    method: "post",
    data: formData,
  });
}

export function submitTestAnswers(params) {
  
  
  
  const requestData = {
    type: params.type, 
    answer: params.answer, 
  };
  if (params.grouping) {
    requestData.grouping = params.grouping;
  }

  
  if (params.hipTestId) {
    requestData.hip_test_id = params.hipTestId;
  }

  
  if (params.hipTestRecordId) {
    requestData.hip_test_record_id = params.hipTestRecordId;
  }

  return request({
    url: "/Unittest/submitTestAnswers",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: requestData,
  });
}

export function getSubmitTestAnswersInfo(params) {
  const formData = new FormData();
  formData.append("hip_test_record_id", params.hipTestRecordId);
  return request({
    url: "/Unittest/getSubmitTestAnswersInfo",
    method: "post",
    data: formData,
  });
}

export function getReadingComprehensionTestAnswersInfo(params) {
  const formData = new FormData();
  formData.append("hip_test_record_id", params.hipTestRecordId);
  return request({
    url: "/Exercises/getSubmitTestAnswersInfo",
    method: "post",
    data: formData,
  });
}

export function getUserIsModify(params) {
  const formData = new FormData();
  formData.append("hip_test_record_id", params.hipTestRecordId);
  return request({
    url: "/Unittest/getUserIsModify",
    method: "post",
    data: formData,
  });
}

export function getReadingComprehensionUserIsModify(params) {
  const formData = new FormData();
  formData.append("hip_test_record_id", params.hipTestRecordId);
  return request({
    url: "/Exercises/getUserIsModify",
    method: "post",
    data: formData,
  });
}

export function wordTranslation(params) {
  const formData = new FormData();
  formData.append("word", params.word);
  return request({
    url: "/Exercises/wordTranslation",
    method: "post",
    data: formData,
  });
}

export function submitTestAnswersMod(params) {
  return request({
    url: "/Unittest/submitTestAnswersMod",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      hip_test_record_id: params.hipTestRecordId,
      type: params.type, 
      answer: params.answer, 
    },
  });
}

export function addWordsToTheWordLibrary(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("word", params.word);
  return request({
    url: "/Exercises/addWordsToTheWordLibrary",
    method: "post",
    data: formData,
  });
}

export function addMistakebookShuci(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("vocabulary_ids", params.vocabularyIds);
  return request({
    url: "/Mistakebook/addShuci",
    method: "post",
    data: formData,
  });
}

export function addMistakebookShengci(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("vocabulary_ids", params.vocabularyIds);
  return request({
    url: "/Mistakebook/addShengci",
    method: "post",
    data: formData,
  });
}

export function addShuci(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("vocabulary_ids", params.vocabularyIds);
  return request({
    url: "/Exercises/addShuci",
    method: "post",
    data: formData,
  });
}

export function addShengci(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("vocabulary_ids", params.vocabularyIds);
  return request({
    url: "/Exercises/addShengci",
    method: "post",
    data: formData,
  });
}

export function submitExerciseAnswers(params) {
  return request({
    url: "/Exercises/submitExercisesAnswers",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      unit_id: params.unitId,
      answer: params.answer,
    },
  });
}

export function submitExercisesAnswersRe(params) {
  return request({
    url: "/Exercises/submitExercisesAnswersRe",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      unit_id: params.unitId,
      answer: params.answer,
    },
  });
}
export function submitExercisesTestAnswers(params) {
  return request({
    url: "/Exercises/submitTestAnswers",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      hip_test_id: params.unitId,
      answer: params.answer,
      type: params.type,
    },
  });
}

export function submitReadingComprehensionTestAnswersMod(params) {
  return request({
    url: "/Exercises/submitTestAnswersMod",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      hip_test_record_id: params.hipTestRecordId,
      type: params.type,          
      answer: params.answer,      
    },
  });
}

export function getReviewStatus() {
  return request({
    url: "/Review/getReviewStatus",
    method: "post",
  });
}

export function getReviewFirstWord() {
  return request({
    url: "/Review/getUnitFirstWord",
    method: "post",
  });
}

export function submitReviewAnswer(params) {
  const formData = new FormData();
  formData.append("type", params.type);
  formData.append("difficult_study_id", params.difficultStudyId);
  formData.append("current_index", params.currentIndex);
  formData.append("action", params.action);
  formData.append("answer", params.answer || "");
  return request({
    url: "/Review/submitAnswer",
    method: "post",
    data: formData,
  });
}

export function getReviewNextWord(params) {
  const formData = new FormData();
  formData.append("groupid", params.groupid);
  formData.append("current_index", params.currentIndex);
  return request({
    url: "/Review/getNextWordForReview",
    method: "post",
    data: formData,
  });
}

export function getUserStudyWord(code) {
  const formData = new FormData();
  if (code !== undefined && code !== null) {
    formData.append("code", code);
  }
  return request({
    url: "/Studyrecord/getUserStudyWord",
    method: "post",
    data: formData,
  });
}

export function getUserTestRecord(page, limit) {
  const formData = new FormData();
  formData.append("page", page || "1");
  formData.append("limit", limit || "10");
  return request({
    url: "/Studyrecord/getUserTestRecord",
    method: "post",
    data: formData,
  });
}

export function getLearningProgress(page, limit) {
  const formData = new FormData();
  formData.append("page", page || "1");
  formData.append("limit", limit || "10");
  return request({
    url: "/Studyrecord/getLearningProgress",
    method: "post",
    data: formData,
  });
}

export function getPhonicsUnitFirstWord(params) {
  const formData = new FormData();
  formData.append("unit_id", params.unitId);
  formData.append("type", params.type || "3");
  return request({
    url: "/Phonics/getUnitFirstWord",
    method: "post",
    data: formData,
  });
}

export function getPhonicsNextWord(params) {
  const formData = new FormData();
  formData.append("type", params.type || "3");
  formData.append("difficult_vocabulary_id", params.difficultVocabularyId);
  formData.append("current_index", params.currentIndex);
  return request({
    url: "/Phonics/getNextWord",
    method: "post",
    data: formData,
  });
}

export function searchWord(params) {
  const formData = new FormData();
  
  formData.append("keyword", params.keyword || "");
  formData.append("unit_id", params.unit_id || 0);
  return request({
    url: "/index/searchWord",
    method: "post",
    data: formData,
  });
}
